<template>
  <div>
    <div class="row">
      <div class="col-sm-10">
        <div class="text-center mx-auto">
          <img
            src="https://akbarmaliki.github.io/portofolio/_nuxt/img/strap.dc23f7d.png"
            class="mx-auto kinoLightBox img-fluid animate__animated animate__fadeInDown"
            style="width:70px;height:100px;position:absolute;top:-80px;z-index:5;"
          />
        </div>
        <div
          style="font-family:Titillium Web;line-height: 1.5;background:black;"
          class="p-3 ml-1 mr-1  shadow-lg rounded-lg animate__animated animate__fadeInDown"
      :style="`${$store.state.data.layout.background_card2}`"
        >

       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#273036" fill-opacity="1" d="M0,224L40,229.3C80,235,160,245,240,240C320,235,400,213,480,186.7C560,160,640,128,720,144C800,160,880,224,960,229.3C1040,235,1120,181,1200,176C1280,171,1360,213,1400,234.7L1440,256L1440,0L1400,0C1360,0,1280,0,1200,0C1120,0,1040,0,960,0C880,0,800,0,720,0C640,0,560,0,480,0C400,0,320,0,240,0C160,0,80,0,40,0L0,0Z"></path></svg>
       <p class="font-bold underline italic text-center" style="margin-top:-30px;">ID CARD</p>
          <div class="text-center">
          <a v-if="about.length>0" :href="about[0].github">
        <button
          type="button"
          class="btn btn-sm btn-style9 float-right"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"

          style="margin-left:5px;padding:3px;padding-top:0px;padding-bottom:0px;"
        >
          <img src="https://upload.egov.balangankab.go.id/svg/social-github-circular.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
        </button>
      </a>
      <a v-if="about.length>0" :href="about[0].linkedin">
        <button
          type="button"
          class="btn btn-sm btn-style9 float-right"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"

          style="margin-left:5px;padding:3px;padding-top:0px;padding-bottom:0px;"
        >
        <img src="https://upload.egov.balangankab.go.id/svg/social-linkedin-circular.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
        </button>
      </a>
      <a v-if="about.length>0" :href="about[0].instagram">
        <button
          type="button"
          class="btn btn-sm btn-style9 float-right"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"

          style="margin-left:5px;padding:3px;padding-top:0px;padding-bottom:0px;"
        >
         <img src="https://upload.egov.balangankab.go.id/svg/social-instagram.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
        </button>
      </a>
      <a v-if="about.length>0" :href="about[0].facebook">
        <button
          type="button"
          class="btn btn-sm btn-style9 float-right"
                  :style="`${$store.state.data.layout?$store.state.data.layout.button_color:''}`"

          style="margin-left:5px;padding:3px;padding-top:0px;padding-bottom:0px;"
        >
        <img src="https://upload.egov.balangankab.go.id/svg/social-facebook.svg" 
             class="d-inline" style="height:20px;width:20px;filter: brightness(0) invert(1);" alt="">
        </button>
      </a>
          </div>
          <hr class="style4 mt-4 mb-4" />
          <div class="row">
            <div class="col-sm-4 text-center mx-auto">
              <div class="text-center mx-auto">
                <a v-if="about.length>0" :href="`https://wa.me/${about[0].nohp}`">

                <img
                  src="@/static/photo/whatsapp.png"
                  v-viewer
                  class="kinoLightBox img-thumbnail mx-auto"
                  style="border-radius: 20px;width:130px;height:130px;"
                />
                </a>
                <br>
                <p class="cursor-pointer font-bold" ><span class="typcn typcn-message text-green-600"></span> WA AKU !</p>
              </div>
            </div>
            <div class="col-sm-8 mt-1 text-sm" v-if="about.length>0">
              <tr>
                <td>Nama</td>
                <td class="pl-1 pr-1">&nbsp;:&nbsp;</td>
                <td class="font-bold">{{about[0].nama}}</td>
              </tr>
              <tr>
                <td>No hp</td>
                <td class="pl-1 pr-1">&nbsp;:&nbsp;</td>
                <td class="font-bold">{{about[0].nohp}}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td class="pl-1 pr-1">&nbsp;:&nbsp;</td>
                <td class="font-bold">{{about[0].email}}</td>
              </tr>
              <tr>
                <td>Alamat</td>
                <td class="pl-1 pr-1">&nbsp;:&nbsp;</td>
                <td
                  class="font-bold"
                >
                <p v-html="about[0].alamat">
                </p>
                <br>
               
                </td>
              </tr>
              <hr class="style4 mt-4 mb-4" />
            </div>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320"><path fill="#273036" fill-opacity="1" d="M0,224L40,229.3C80,235,160,245,240,240C320,235,400,213,480,186.7C560,160,640,128,720,144C800,160,880,224,960,229.3C1040,235,1120,181,1200,176C1280,171,1360,213,1400,234.7L1440,256L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"></path></svg>
        </div>
      </div>
    </div>
    <h1 style="font-size:1px;opacity:0.1;">Contact TA_Maliki / Taufik Akbar Maliki PORTOFOLIO WEBSITE OFFICIAL</h1>
  </div>
</template>
<script>
import axios from 'axios'
// let rdb = firebase.database()
import autophp from '@/plugins/autophp'
let sdb = new autophp()
let urlnya='https://gis.officialapp.my.id'
export default {
  layout: 'a-5',
  data () {
    return {
      about:[]
    }
  },
  methods: {
    wame () {
      window.location = 'https://wa.me/6282251970006'
    }
  },
  mounted () {
    
    sdb.collection("app_portofolio_about",false,urlnya).doc().select(`select * from app_portofolio_about where iduser='${this.$store.state.id}'`).then(res => {
        this.about=res;
        this.$forceUpdate();
    });
    
  },
}
</script>
